import Vue from 'vue';
import Router from 'vue-router';
import paths from './paths';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import store from '@/store';
import { hasFeatureAccess, hasLegacyRoleAccess } from '@/commons/utils';

Vue.use(Router);
const router = new Router({
    base: '/',
    linkActiveClass: 'active',
    routes: [
        ...paths,
        {
            path: '/permission',
            component: () => import('@/views/Permission/PermissionMatrix.vue'),
            meta: { requiresAuth: true, roleId: 1, permissionKey: 'setting' }
        }
    ],
    mode: 'history'
});
const DEFAULT_TITLE = process.env.NODE_ENV === "production" ? 'DHD Logistics' : 'TEST';
// router gards
router.beforeEach(async (to, from, next) => {
    NProgress.start();
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (localStorage.getItem('jwt') == null) {
            next({
                path: '/login',
                params: { nextUrl: to.fullPath }
            })
        } else {
            let user = store.state.authentication.user || JSON.parse(localStorage.getItem('user'));
            const permissionRoute = [...to.matched].reverse().find(record => record.meta && record.meta.permissionKey);
            let canAccess = false;

            if (permissionRoute && permissionRoute.meta.permissionKey) {
                if (!store.state.permission.loaded) {
                    try {
                        await store.dispatch('permission/loadMatrix');
                    } catch (error) {
                        console.warn('permission/loadMatrix failed in router guard', error);
                    }
                }
                canAccess = hasFeatureAccess(store, permissionRoute.meta.permissionKey, 1);
            } else {
                canAccess = hasLegacyRoleAccess(user ? user.roleid : 0, to.meta.roleId);
            }

            if (canAccess) {
                next()
            } else {
                next({
                    path: '/'
                })
            }
            Vue.nextTick(() => {
                document.title = to.meta.title ? to.meta.title + (to.params.Pid ? ' #' + to.params.Pid : '') + ' | ' + DEFAULT_TITLE : DEFAULT_TITLE;
            });
        }
    } else if (to.matched.some(record => record.meta.public)) {
        if (localStorage.getItem('jwt') == null) {
            next()
        }
        else {
            next({
                path: '/'
            })
        }
    } else {
        next()
    }
});

router.afterEach((to, from) => {
    NProgress.done();
});

export default router;
